export default __webpack_public_path__ + "static/media/step8_img3.081e1f86.png";